export default "__VITE_ASSET__BPD8z4Pp__"